import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class AdminDataService extends BaseService {

	constructor() {	
		super();
	}
	
	async getGPSLocations(companyId, tractorId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/admin/gpslocations/' + companyId + '/tractors/' + tractorId + params);		
		return data;		
	}
	
	exportGPSLocations(companyId, tractorId, paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/admin/gpslocations/' + companyId + '/tractors/' + tractorId + '/export' + params);		
	};	
	
	async getFuel(companyId, refType, unitId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/admin/fuel-purchases/' + companyId + '/units/' + refType + '/' + unitId + params);		
		return data;		
	}	
	
	exportFuel(companyId, refType, unitId, paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/admin/fuel-purchases/' + companyId + '/units/' + refType + '/' + unitId + '/export' + params);		
	};	
	
	async getDistanceSummaries(companyId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/admin/distance-summaries/'+ companyId + params);		
		return data;		
	}
	
	exportDistanceSummaries(companyId, paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/admin/distance-summaries/' + companyId + '/export' + params);		
	};	

	async getTrips(companyId, tractorId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/admin/trips/' + companyId + '/tractors/' + tractorId +  params);		
		return data;		
	}
	
	exportTrips(tractorId, paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/trips/tractors/' + tractorId + '/export' + params);		
	};		
	
	async getTripStops(companyId, tractorId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/admin/trip-stops/' + companyId + '/tractors/' + tractorId +  params);		
		return data;		
	}	
	
	exportTripStops(tractorId, paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/trip-stops/tractors/' + tractorId + '/export' + params);		
	};	
	
}


